export default {
  ControlDirection: '控制方向',
  InDirection: '入方向',
  OutDirection: '出方向',
  ControlType: '控制类型',
  Allow: '允许',
  Reject: '拒绝',
  AccessControlRelatedNet: '访问规则-已关联网关',
  ContinueRelate: '继续关联',
  GatewayMoreThan100: (gatewayNames: string) => `网关 ${gatewayNames} 关联的规则数超过100条,继续关联将剔除以上网关继续提交。`,
  AllGatewayMoreThan: (gatewayNames: string) => `网关 ${gatewayNames} 关联的规则数超过100条,请重新选择网关`,
}